import React from 'react';
import styled from 'styled-components';

import { LoadingIndicator } from '@spotify-internal/encore-creator-web';

import { Delay } from '../../../../../shared/components/Delay';

import { LightModeLoadingIndicator } from '../../../Elements';

import { DialogWrapper } from '../DialogWrapper';

const LoadingWrapper = styled(DialogWrapper)`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
`;

export function FormLoading() {
  return (
    <LoadingWrapper>
      <Delay time={300}>
        <LightModeLoadingIndicator indicatorSize={LoadingIndicator.lg} />
      </Delay>
    </LoadingWrapper>
  );
}
